export default __webpack_public_path__ + "403b2500dd68c74c3f5e30e5d795faa7.png";